import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class ModelThicknessProperty extends ObservablePropertyDescriptorObject {

    top = new PropertyDescriptor(0, "上", "布局", "double", "#anticon - icons - y_coordinate");
    right = new PropertyDescriptor(0, "右", "布局", "double", "#anticon-icons-y_coordinate");
    bottom = new PropertyDescriptor(0, "下", "布局", "double", "#anticon-icons-y_coordinate");
    left = new PropertyDescriptor(0, "左", "布局", "double", "#anticon-icons-y_coordinate");

    constructor(opts = {}) {
        super();

        if (typeof opts === "number") {
            this.top.value = opts;
            this.right.value = opts;
            this.bottom.value = opts;
            this.left.value = opts;
        }
        else {
            for (var p in opts) {
                this[p].value = opts[p];
            }
        }

        this.defineAllProperties();
    }

    toString() {
        return `${this.top}px ${this.right}px ${this.bottom}px ${this.left}px`;
    }
    
    toArray() {
        return [this.top, this.right, this.bottom, this.left];
    }
}
